.feedback {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
}
.correctLabel {
  color: var(--tuna-feedback-success-content);
  font-weight: 600;
}
.incorrectLabel {
  color: var(--tuna-feedback-error-content);
  font-weight: 600;
}
.tip {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
  margin: 0;
}
